import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

const PageSection = styled.section`
  padding: 100px 0;
  
  h1 {
    margin-bottom: 40px;
    font-weight: 700;
    color: #333;
    
    span {
      color: #2e7d32;
    }
  }
  
  h2 {
    font-size: 1.5rem;
    color: #2e7d32;
    margin: 30px 0 15px;
    font-weight: 600;
  }
  
  p {
    color: #555;
    margin-bottom: 20px;
    line-height: 1.7;
  }
  
  ul {
    margin-bottom: 25px;
    
    li {
      margin-bottom: 10px;
      color: #555;
    }
  }
  
  .last-updated {
    font-style: italic;
    color: #777;
    margin-bottom: 30px;
  }
`;

const TermsConditions = () => {
  useEffect(() => {
    document.title = 'Terms & Conditions | Bering Solutions';
  }, []);
  
  return (
    <PageSection>
      <Container>
        <h1>Terms & <span>Conditions</span></h1>
        <p className="last-updated">Last Updated: May 30, 2025</p>
        
        <p>
          Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the website beringsolutions.com operated by Bering Solutions LLC ("us", "we", or "our").
        </p>
        <p>
          Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the Service.
        </p>
        <p>
          By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
        </p>
        
        <h2>Use of Our Service</h2>
        <p>
          Our website provides information about our land buying services. By using our website, you represent that you are at least 18 years of age and are legally capable of entering into binding contracts.
        </p>
        <p>
          You agree to use our Service only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website.
        </p>
        
        <h2>Property Information</h2>
        <p>
          When you submit information about your property through our website:
        </p>
        <ul>
          <li>You confirm that all information provided is accurate, current, and complete.</li>
          <li>You acknowledge that any offers we make are based on the information you provide, and inaccurate information may result in an adjustment or withdrawal of offers.</li>
          <li>You represent that you have legal authority to sell the property or are authorized to act on behalf of the property owner.</li>
        </ul>
        
        <h2>Cash Offers and Transactions</h2>
        <p>
          Any cash offer provided through our website is:
        </p>
        <ul>
          <li>Subject to verification of property details, title search, and property inspection.</li>
          <li>Non-binding until a formal purchase agreement is signed by all parties.</li>
          <li>Valid for a specified period, as indicated in the offer.</li>
        </ul>
        <p>
          All property transactions will be governed by separate purchase agreements, which will supersede any information provided on the website.
        </p>
        
        <h2>Intellectual Property</h2>
        <p>
          The Service and its original content, features, and functionality are and will remain the exclusive property of Bering Solutions LLC and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries.
        </p>
        <p>
          Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Bering Solutions LLC.
        </p>
        
        <h2>Links To Other Web Sites</h2>
        <p>
          Our Service may contain links to third-party websites or services that are not owned or controlled by Bering Solutions LLC.
        </p>
        <p>
          Bering Solutions LLC has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that Bering Solutions LLC shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.
        </p>
        
        <h2>Limitation of Liability</h2>
        <p>
          In no event shall Bering Solutions LLC, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
        </p>
        <ul>
          <li>Your access to or use of or inability to access or use the Service;</li>
          <li>Any conduct or content of any third party on the Service;</li>
          <li>Any content obtained from the Service; and</li>
          <li>Unauthorized access, use, or alteration of your transmissions or content.</li>
        </ul>
        
        <h2>Disclaimer</h2>
        <p>
          Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement, or course of performance.
        </p>
        
        <h2>Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the laws of Florida, United States, without regard to its conflict of law provisions.
        </p>
        <p>
          Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect.
        </p>
        
        <h2>Changes to Terms</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
        </p>
        <p>
          By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
        </p>
        
        <h2>Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us:
        </p>
        <p>
          Bering Solutions LLC<br />
          14 NE 1st Ave Ste 1403 #140<br />
          Miami, FL 33132<br />
          Email: connect@beringsolutions.com<br />
          Phone: 786-460-6046
        </p>
      </Container>
    </PageSection>
  );
};

export default TermsConditions;
